import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';
import { getResRegulatorias, getMultasRegulatorias } from '../../service/apiBackEnd'

export default function ResolucionesRegulatorias(props) {

    const [allData, setAllData] = useState([]);
    const [allMultas, setAllMultas] = useState([]);
    const [enrichedData, setEnrichedData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getResRegulatorias();
            console.log("DATA", res);
            setAllData(res);
        };
        fetchData();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            const res = await getMultasRegulatorias();
            console.log("MULTAS", res);
            setAllMultas(res);
        };
        fetchData();
    }, []);

    useEffect(() => {
        const getMediaUrl = async (mediaId) => {
            try {
                const response = await fetch(`http://epas.test.di.dgi.loc/wp-json/wp/v2/media/${mediaId}`);
                const mediaData = await response.json();
                return mediaData.source_url;
            } catch (error) {
                console.error("Error fetching media:", error);
                return null;
            }
        };

        const fetchMediaUrls = async () => {
            const updatedData = await Promise.all(
                allMultas.map(async (elem) => {
                    const multa = elem.acf?.multas
                        ? await getMediaUrl(elem.acf.multas)
                        : null;

                    return { ...elem, multa };
                })
            );
            setEnrichedData(updatedData);
        };

        if (allMultas.length > 0) {
            fetchMediaUrls();
        }
    }, [allMultas]);

    console.log("multas", allMultas)
    return (
        <Container>
            <Row>
                <h1 className="mt-5 mb-4">Resoluciones regulatorias</h1>
                <hr></hr>
                <Row>
                    <h3>Multas</h3>
                    {allMultas.map((elem) => {
                        console.log(elem)
                        return (
                            <>
                                <h6>{elem.acf.titulo}</h6>
                                {elem.acf.multas && (
                                    <a href={elem.acf.multas} 
                                    style={{ width: "fit-content", marginBottom: "1em" }} 
                                    target="_blank" rel="noopener noreferrer" 
                                    download className={styles.btnDescarga}>
                                        Descargar Archivo
                                    </a>
                                )}
                            </>
                        )
                    })}
                </Row>
                <Row className='mb-5'>
                    <hr></hr>
                    <h3>Resoluciones</h3>
                    {allData.map((elem) => {
                        console.log(elem)
                        return (
                            <li>{elem.acf.resolucion_regulatoria}</li>
                        )
                    })}
                </Row>
            </Row>

        </Container>
    )
}

